<template>
	<div id="app">
		<publicHeader :menus="menus" :cur="curr" />
		<router-view @headerCur="changeCur" :block="menus[curr]" />
		<publicFooter :obj="master" />
		<backTop />
	</div>
</template>

<script>
	import publicHeader from '@/components/common/header'
	import publicFooter from '@/components/common/footer'
	import backTop from '@/components/common/backTop'
	
	import axios from '@/axios/'

	export default {
		components: {
			publicHeader,publicFooter,backTop
		},
		data(){
			return{
				curr:0,
				menus: [],		//顶部菜单
				master:{},		//
			}
		},
		async created(){
			try{
				let {data} = await axios('/getMenus');
				if(data.code==200){
					this.menus = data.data;
				}
			}catch(e){
				this.menus = [];
			}
			try{
				let {data} = await axios('/getmaster');
				if(data.code==200){
					this.master = data.data;
				}
			}catch(e){
				this.master = {};
			}
		},
		methods:{
			changeCur(cur){
				this.curr = cur;
			}
		}
	}
</script>

<style>
	body,
	ul,
	ol,
	li,
	p,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	form,
	fieldset,
	table,
	td,
	img,
	div,
	dl,
	dt,
	dd,
	input,
	i,
	b {
		margin: 0;
		padding: 0;
		border: 0;
		font-weight: normal;
		font-style: normal;
	}

	ul,
	ol {
		list-style-type: none;
	}

	select,
	input,
	img {
		vertical-align: middle;
		outline: none;
	}

	a {
		text-decoration: none;
	}

	a {
		blr: "expression(this.onFocus=this.blur())"
	}

	a {
		outline: none;
	}

	a {
		color: #555;
	}

	html {
		overflow-x: hidden;
	}

	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	.clearfix {
		zoom: 1;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	body {
		font-family: "Microsoft Yahei", "微软雅黑", verdana;
		color: #333;
		background: #E9EAED;
		padding-top: 80px;
		line-height: 1.5;
	}

	.active {
		color: #00c1de !important;
	}
</style>
